import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const BUTTON_VARIANTS = ['default', 'primary-light', 'secondary', 'third', 'outline', 'outline-dashed', 'outline-success', 'outline-danger', 'outline-third', 'ghost', 'link', 'destructive', 'success', 'dark', 'mission', 'merit', 'done'];

const BADGE_VARIANTS = ['default', 'primary-light', 'secondary', 'third', 'destructive', 'outline', 'success', 'success-light', 'warning', 'danger', 'info', 'more', 'bright', 'attention', 'neutral', 'neutral-lightest'];

export function ButtonsSection() {
  return (
    <ShowcaseSection
      id="buttons"
      title="Buttons & Badges"
      description="17 variantes de Button + 16 de Badge via class-variance-authority"
    >
      <ShowcaseItem
        label="Button — Variantes"
        description="17 estilos disponiveis"
      >
        <div className="flex flex-wrap gap-2">
          {BUTTON_VARIANTS.map(variant => (
            <Button
              key={variant}
              variant={variant}
              size="sm"
            >
              {variant}
            </Button>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Button — Tamanhos"
        description="xxs, xs, sm, default, md, lg"
      >
        <div className="flex flex-wrap items-center gap-2">
          <Button size="xxs">xxs</Button>
          <Button size="xs">xs</Button>
          <Button size="sm">sm</Button>
          <Button size="default">default</Button>
          <Button size="md">md</Button>
          <Button size="lg">lg</Button>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Button — Estados"
        description="Disabled, fullWidth"
      >
        <div className="flex flex-wrap items-center gap-2">
          <Button disabled>Disabled</Button>
          <Button
            variant="outline"
            disabled
          >
            Disabled outline
          </Button>
        </div>
        <div className="mt-3">
          <Button fullWidth>Full Width</Button>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Badge — Variantes"
        description="16 estilos disponiveis"
      >
        <div className="flex flex-wrap gap-2">
          {BADGE_VARIANTS.map(variant => (
            <Badge
              key={variant}
              variant={variant}
            >
              {variant}
            </Badge>
          ))}
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Badge — Tamanhos"
        description="xs, sm, default"
      >
        <div className="flex flex-wrap items-center gap-2">
          <Badge size="xs">xs</Badge>
          <Badge size="sm">sm</Badge>
          <Badge size="default">default</Badge>
        </div>
      </ShowcaseItem>

      <ShowcaseItem
        label="Badge — Square vs Pill"
        description="Variante quadrada (rounded-sm vs rounded-full)"
      >
        <div className="flex flex-wrap items-center gap-2">
          <Badge
            variant="primary-light"
            square={false}
          >
            Pill
          </Badge>
          <Badge
            variant="primary-light"
            square
          >
            Square
          </Badge>
          <Badge variant="success">Pill</Badge>
          <Badge
            variant="success"
            square
          >
            Square
          </Badge>
        </div>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
